const COMMON_URL = `${process.env.REACT_APP_COMMON_SERVICE_ORIGIN_URL}/report`

const GeneratedReportApiUrls = {
    GET: `${COMMON_URL}/generated-report/hdr/get`,
    GET_CUSTOMER: `${COMMON_URL}/generated-report/hdr/get-for-customer`
}

export default GeneratedReportApiUrls